import { useEffect, useRef } from "react";
import { Grid } from "../../../../../../Layout/Grid/GridView";
import Loading from "../../../../../../../components/Loading";

const PromotersStatsView = ({ data }) => {
  const gridPromoterStatRef = useRef();

  return data ? (
    <div className="row mt-2">
      <div className="col-12">
        <Grid
          ref={gridPromoterStatRef}
          rows={data}
          height="95vh"
          pagination={true}
          cols={[

            {
              headerName: "Nome", field: "name",
              cellRenderer: (params) => {
                return (
                  <span className="imgSpanLogo">
                    {params.data.image && (
                      <img
                        alt={`${params.data.image}`}
                        src={params.data.image}
                        className="img-fluid"
                        style={{
                          width: '26px',
                          height: '26px',
                          borderRadius: '100px'
                        }}
                      />
                    )}
                    &nbsp;{params.data.name}
                  </span>)
              }
            },
            { headerName: "Guest List", cellStyle: { textAlign: 'center' }, field: "guestlistStats" },
            { headerName: "Mesas", cellStyle: { textAlign: 'center' }, field: "tabletStats" },
            { headerName: "Bilhetes", cellStyle: { textAlign: 'center' }, field: "ticketStats" },
          ]}
        />
      </div>
    </div>
  ) : <Loading />;
};

export default PromotersStatsView;
